import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LearningPlanGoalInterface } from '../../+models';
import { InkApi, ModelInkApiBase } from '../shared';

@Injectable({ providedIn: 'root' })
export class LearningPlanGoalInkApi extends ModelInkApiBase {
  constructor(api: InkApi) {
    super(api, 'learning-plan-goal');
  }

  search(
    searchTerm?: string,
    filters?: { [key: string]: string | number | number[] },
    pagination?: { from?; amount? },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: LearningPlanGoalInterface[]; count: number }> {
    const params = this._getHttpParams({
      searchTerm: searchTerm || '',
      filters: filters || {},
      columns: columns || [],
      sorting: sorting || {},
      pagination: pagination || {},
    });
    return this.get<{ results: LearningPlanGoalInterface[]; count: number }>('', params);
  }
}
